import { render, staticRenderFns } from "./LoyaltyPoints.vue?vue&type=template&id=3676b5e2&lang=html&"
import script from "./LoyaltyPoints.vue?vue&type=script&lang=js&"
export * from "./LoyaltyPoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports